export default __webpack_public_path__ + "static/Scott Smith-8c610c3155b7f219f0c8d6d50fab9043.png";